import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '@/api/languages';
import type { CreateLanguageInput, UpdateLanguageInput } from '@/types/language';

export const LANGUAGES_KEY = ['languages'] as const;

export function useLanguages() {
  return useQuery({ queryKey: LANGUAGES_KEY, queryFn: api.listLanguages });
}

export function useCreateLanguage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateLanguageInput) => api.createLanguage(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: LANGUAGES_KEY }),
  });
}

export function useUpdateLanguage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ code, input }: { code: string; input: UpdateLanguageInput }) =>
      api.updateLanguage(code, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: LANGUAGES_KEY }),
  });
}

export function useDeleteLanguage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => api.deleteLanguage(code),
    onSuccess: () => qc.invalidateQueries({ queryKey: LANGUAGES_KEY }),
  });
}
